import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    DateField,
    Filter,
    SearchInput,
    Edit,
    SimpleForm,
    TextInput,
    Show,
    SimpleShowLayout,
    ReferenceField,
    ArrayField,
} from 'react-admin';

// Filter component for knocks
const KnockFilter = (props: any) => (
    <Filter {...props}>
        <SearchInput source="message" alwaysOn />
        <SearchInput source="sales_rep_email" label="Sales Rep Email" />
        <SearchInput source="status" />
    </Filter>
);

// List component for knocks
export const KnockList = (props: any) => (
    <List {...props} filters={<KnockFilter />} sort={{ field: 'created_at', order: 'DESC' }}>
        <Datagrid rowClick="show">
            <TextField source="uuid" label="UUID" sortable={false} />
            <TextField source="sales_rep_email" label="Sales Rep Email" sortable={false} />
            <TextField source="sales_rep_uuid" label="Sales Rep UUID" sortable={false} />
            <ReferenceField source="homeowner_id" reference="users" label="Homeowner" sortable={false}>
                <TextField source="email" />
            </ReferenceField>
            <TextField source="message" sortable={false} />
            <TextField source="status" sortable={false} />
            <DateField source="created_at" />
            <DateField source="responded_at" />
        </Datagrid>
    </List>
);

// Edit component for knocks
export const KnockEdit = (props: any) => (
    <Edit {...props}>
        <SimpleForm>
            <TextField source="sales_rep_email" label="Sales Rep Email" />
            <TextField source="sales_rep_uuid" label="Sales Rep UUID" />
            <ReferenceField source="homeowner_id" reference="users" label="Homeowner">
                <TextField source="email" />
            </ReferenceField>
            <TextInput source="message" multiline rows={4} />
            <TextInput source="status" />
            <DateField source="created_at" />
            <DateField source="responded_at" />
        </SimpleForm>
    </Edit>
);

// Show component for knocks
export const KnockShow = (props: any) => (
    <Show {...props}>
        <SimpleShowLayout>
            <TextField source="uuid" label="UUID" />
            <TextField source="sales_rep_email" label="Sales Rep Email" />
            <TextField source="sales_rep_uuid" label="Sales Rep UUID" />
            <ReferenceField source="homeowner_id" reference="users" label="Homeowner">
                <TextField source="email" />
            </ReferenceField>
            <TextField source="message" />
            <TextField source="status" />
            <DateField source="created_at" />
            <DateField source="responded_at" />
            <TextField source="conversation_id" />
            
            {/* Show responses */}
            <ArrayField source="responses" label="Responses">
                <Datagrid bulkActionButtons={false}>
                    <TextField source="response_type" />
                    <TextField source="message" />
                    <DateField source="created_at" />
                </Datagrid>
            </ArrayField>
        </SimpleShowLayout>
    </Show>
); 